var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeSocialLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.853 3.90477C30.6775 3.27861 30.3356 2.71172 29.8636 2.26435C29.3783 1.80323 28.7835 1.47338 28.1353 1.30594C25.7096 0.666561 15.9911 0.666561 15.9911 0.666561C11.9396 0.620465 7.88902 0.823208 3.86234 1.27364C3.21417 1.45346 2.62049 1.79068 2.13409 2.25531C1.65618 2.71514 1.31001 3.28219 1.12918 3.90348C0.694781 6.24365 0.483721 8.6198 0.498844 10.9999C0.483344 13.3779 0.693886 15.7532 1.12918 18.0963C1.30614 18.715 1.65101 19.2795 2.13022 19.7354C2.60943 20.1914 3.20618 20.5208 3.86234 20.6951C6.32039 21.3332 15.9911 21.3332 15.9911 21.3332C20.0478 21.3794 24.1035 21.1766 28.1353 20.7261C28.7835 20.5587 29.3783 20.2289 29.8636 19.7677C30.3354 19.3205 30.6769 18.7535 30.8517 18.1273C31.2975 15.788 31.5142 13.4109 31.4988 11.0296C31.5324 8.63822 31.3159 6.24987 30.853 3.90348V3.90477ZM12.9014 15.4226V6.57852L20.9873 11.0012L12.9014 15.4226Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSocialLogo);
export default __webpack_public_path__ + "static/media/youtube-social-logo.6863ec5360a52aad848e6453043d31d7.svg";
export { ForwardRef as ReactComponent };